<template>
    <div class="garden-help-register garden-help-auth-container h-100">
        <b-row class="w-100 h-100">
            <b-col lg="3" md="3" sm="3"
                class="garden-help-auth-bg-container garden-help-auth-border-radius position-fixed h-100 p-0">
            </b-col>
            <b-col lg="9" md="9" sm="9" class="form-wizard-register-container">
                <b-row class="justify-content-center">
                    <b-col cols="11">
                        <p class="register-steps-info-garden-help mr-3">
                            Step {{ tabIndex + 1 }} of {{ total_Steps }}
                        </p>
                        <b-progress :value="tabIndex + 1" :max="total_Steps" class="progress-garden-help mb-3"></b-progress>
                    </b-col>
                </b-row>
                <b-form novalidate @submit.prevent="onSubmit" class="register-form" ref="contractorRegisterForm">
                    <b-row class="mt-1">
                        <b-col lg="6" md="9" sm="11" class="m-auto p-0">
                            <b-tabs v-model="tabIndex">
                                <b-tab title="">

                                    <PersonalData :type="type" :first_name.sync="first_name"
                                        :invalid_first_name="invalid_first_name" :last_name.sync="last_name"
                                        :invalid_last_name="invalid_last_name" :email.sync="email"
                                        :invalid_email="invalid_email" :invalid_correct_email="invalid_correct_email"
                                        :phone_number.sync="phone_number" :invalid_phone_number="invalid_phone_number"
                                        :contact_through.sync="contact_through" :password.sync="password"
                                        :invalid_password="invalid_password"
                                        :invalid_correct_password="invalid_correct_password"
                                        :confirm_password.sync="confirm_password"
                                        :invalid_confirm_password="invalid_confirm_password"
                                        :invalid_correct_confirm_password="invalid_correct_confirm_password" />


                                    <PropertyDetails :type="type" :address.sync="address" :longitude.sync="longitude"
                                        :latitude.sync="latitude" :invalid_address="invalid_address"
                                        :invalid_address_longitude="invalid_address_longitude"
                                        :invalid_address_latitude="invalid_address_latitude" :country.sync="country"
                                        :county.sync="county" :city.sync="city" :property_type.sync="property_type"
                                        :invalid_property_type="invalid_property_type" :property_size="property_size"
                                        :site_details.sync="site_details" :property_images.sync="property_images"
                                        :invalid_images="invalid_images" />

                                    <DrawMapProperty :map_zoom="map_zoom" :map_center="map_center"
                                        :property_position="property_position" :property_size.sync="property_size"
                                        :polygon_points.sync="polygon_points"
                                        :invalid_property_size="invalid_property_size" />

                                </b-tab>
                            </b-tabs>
                        </b-col>
                    </b-row>
                    <b-row class="">
                        <b-col lg="6" md="9" sm="11" class="m-auto px-1">
                            <b-button-group class="btn-group-form-steps-garden-help">
                                <b-button :disabled="tabIndex === 0" type="button" variant="info-outline" class="back-btn"
                                    @click="clickBack">Back</b-button>
                                <b-button v-show="tabIndex + 1 < total_Steps" type="button" variant="primary"
                                    class="next-btn" @click="clickNext">Continue</b-button>
                                <b-button v-if="tabIndex + 1 == total_Steps && !is_loading" variant="primary"
                                    class="next-btn" type="submit">Submit</b-button>
                                <b-button v-else-if="tabIndex + 1 == total_Steps && is_loading" type="button" disabled
                                    variant="primary" class="next-btn">
                                    <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                                    Loading
                                </b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

import { uploadFiles } from "@/utils/upload-files.js";
import { validatePassword, validateEmail } from "@/utils/validate.js";

import PersonalData from './details_components/PersonalData.vue'
import PropertyDetails from "./details_components/PropertyDetails.vue";
import DrawMapProperty from "./details_components/DrawMapProperty.vue"


export default {
    name: "GardenHelpCustomerRegister",
    components: {
        PersonalData, PropertyDetails, DrawMapProperty
    },
    data() {
        return {
            client_name: "GARDENHELP",
            total_Steps: 1,
            tabIndex: 0,

            type: "register",
            is_loading: false,


            map_zoom: 5,
            map_center: { lat: 53.364379779866695, lng: -6.8271807338634555 },
            property_position: null,
            polygon: null,
            polygon_points: null,

            invalid_property_size: false,

            //////////////// personal data
            first_name: "",
            invalid_first_name: false,
            last_name: "",
            invalid_last_name: false,
            email: "",
            invalid_email: false,
            invalid_correct_email: false,
            phone_number: "",
            invalid_phone_number: false,
            contact_through: null,

            password: "",
            invalid_password: false,
            invalid_correct_password: false,
            confirm_password: "",
            invalid_confirm_password: false,
            invalid_correct_confirm_password: false,
            ///////// property details
            address: null,
            longitude: null,
            latitude: null,
            invalid_address: false,
            invalid_address_longitude: false,
            invalid_address_latitude: false,
            country: null,
            county: null,
            city: null,
            property_type: null,
            invalid_property_type: false,
            property_size: null,
            site_details: null,
            property_images: [],
            property_images_ids: [],
            invalid_images: false,
            selected_property_id: 'new',
            invalid_property_id: false,
            property_list: [],
            selected_property_images: [],
        }
    },
    updated() { },
    mounted() {
    },
    watch: {
        latitude(newval, oldval) {
            if (newval == null) {
                this.property_position = null
            } else {
                this.map_center = { lat: this.latitude, lng: this.longitude };
                this.property_position = { lat: this.latitude, lng: this.longitude };
                this.map_zoom = 20;
            }
        },
    },
    methods: {
        uploadFiles,
        validatePassword,
        validateEmail,
        clickBack() {
            console.log("click back");
            this.tabIndex--;
        },
        clickNext() {
            console.log("click next");
            this.tabIndex = this.tabIndex + 1;
        },

        onSubmit(e) {
            e.preventDefault();
            console.log("click submit")
            this.is_loading = true

            this.checkValidation()
            if (!this.invalid_first_name && !this.invalid_last_name && !this.invalid_email
                && !this.invalid_correct_email && !this.invalid_phone_number
                && !this.invalid_password && !this.invalid_correct_password
                && !this.invalid_confirm_password && !this.invalid_correct_confirm_password
                && !this.invalid_address && !this.invalid_address_latitude && !this.invalid_address_longitude
                && !this.invalid_property_size && !this.invalid_property_type
            ) {

                let formData = new FormData()
                formData.append("client", this.client_name);
                formData.append("email", this.email);
                formData.append("phone", this.phone_number);
                formData.append("user_type", "user");

                axios
                    .post("common/check/unique-email-phone", formData, {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            client: this.client_name
                        },
                    })
                    .then((response) => {
                        console.log(response);
                        if (response.data.user_found == 1) {
                            let message = "The email/phone number has been registered before"
                            this.$fire({
                                // title: "Title",
                                text: message,
                                type: "error",
                                // timer: 3000,
                                customClass: {
                                    container: this.swal_container_class,
                                    confirmButton: this.swal_confirm_button_class,
                                },
                            }).then((r) => {
                                // console.log(r.value);
                                this.is_loading = false;
                                this.tabIndex = 0
                            });
                        } else {
                            this.sendRegisterRequest()
                        }
                    })
                    .catch((error) => {
                        console.log(error.response);
                        this.is_loading = false;
                        this.$fire({
                            // title: "Title",
                            text: error.response.data.error,
                            type: "error",
                            // timer: 3000,
                            customClass: {
                                container: this.swal_container_class,
                                confirmButton: this.swal_confirm_button_class,
                            },
                        }).then((r) => {
                            // console.log(r.value);
                            this.is_loading = false;
                        });
                    });


            } else {
                this.is_loading = false
            }
        },
        checkValidation() {
            if (this.first_name == null || this.first_name == '') {
                this.invalid_first_name = true
            } else {
                this.invalid_first_name = false
            }

            if (this.last_name == null || this.last_name == '') {
                this.invalid_last_name = true
            } else {
                this.invalid_last_name = false
            }

            if (this.email == null || this.email == '') {
                this.invalid_email = true
            } else {
                this.invalid_email = false
                if (this.validateEmail(this.email)) {
                    this.invalid_correct_email = false;
                } else {
                    this.invalid_correct_email = true;
                }
            }
            console.log(this.invalid_email, this.invalid_correct_email)

            if (this.password == null || this.password == "") {
                this.invalid_password = true;
            } else {
                this.invalid_password = false;
                if (this.validatePassword(this.password)) {
                    this.invalid_correct_password = false;
                } else {
                    this.invalid_correct_password = true;
                }
            }
            if (this.confirm_password == null || this.confirm_password == "") {
                this.invalid_confirm_password = true;
            } else {
                this.invalid_confirm_password = false;
                if (this.password == this.confirm_password) {
                    this.invalid_correct_confirm_password = false;
                } else {
                    this.invalid_correct_confirm_password = true;
                }
            }

            if (this.phone_number == null || this.phone_number == '') {
                this.invalid_phone_number = true
            } else {
                this.invalid_phone_number = false
            }

            if (this.address == null || this.address == '') {
                this.invalid_address = true
            } else {
                this.invalid_address = false
                if (this.latitude == null || this.latitude == '') {
                    this.invalid_address_latitude = true
                } else {
                    this.invalid_address_latitude = false
                }
                if (this.longitude == null || this.longitude == '') {
                    this.invalid_address_longitude = true
                } else {
                    this.invalid_address_longitude = false
                }
            }

            if (this.property_size == null || this.property_size == '' || this.property_size == 0) {
                this.invalid_property_size = true
            } else {
                this.invalid_property_size = false
            }
            if (this.property_type == null || this.property_type == '') {
                this.invalid_property_type = true
            } else {
                this.invalid_property_type = false
            }

        },
        async sendRegisterRequest() {
            console.log("in send register request")
            // upload images request
            if (this.property_images != null && this.property_images.length > 0) {
                this.property_images_ids = await this.uploadFiles(
                    this.client_name,
                    this.property_images,
                    null
                );
                console.log("after upload images")
                console.log(this.property_images_ids)
            }

            let requestData = {
                client: this.client_name,
                first_name: this.first_name,
                second_name: this.last_name,
                name: this.first_name + " " + this.last_name,
                email: this.email,
                phone: this.phone_number,
                password: this.password,

                property: {
                    address: this.address,
                    lat: this.latitude,
                    lon: this.longitude,
                    "country": this.country,
                    "county": this.county,
                    "city": this.city,
                    type: this.property_type,
                    size: this.property_size,
                    size_unit: "m2",
                    site_details: this.site_details != null ? this.site_details.toString() : '',
                    map_points: this.polygon_points,
                    images: this.property_images_ids,
                }
            }
            // send register request
            console.log(requestData)
            axios
                .post("user/register-with-property", requestData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                    },
                })
                .then((response) => {
                    console.log(response);
                    this.$fire({
                        // title: "Title",
                        text: "Your account has been registered successfully. You can now login and request a job for your property. ",
                        type: "success",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                        this.is_loading = false;
                        this.$router.push({ name: "GardenHelpLogin" });
                    });
                })
                .catch((error) => {
                    console.log(error.response);
                    this.is_loading = false;
                    this.$fire({
                        // title: "Title",
                        text: error.response.data.error
                            ? error.response.data.error
                            : error.response.data.message,
                        type: "error",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                    });
                });


        }
    }
}
</script>

<style  scoped::v-deep>
@import "../styles/garden-help-auth-styles.css";
@import "../styles/garden-help-styles.css";
@import "../styles/garden-help-button-styles.css";

body {
    max-height: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/customer/Register.vue